export default class slideManager {
    constructor($t){

        this.$container;
        this.$currentPage;
        this.$slideWrap;
        this.$slideContent;
        this.$slideIconBtn;
        this.$slideIllust;


        this.status = {
            current : 1,
            prevCurrent : 1,
            dir : "",
        }

        this.conf = {
            max : 6,
        }

        this.pointtl = '';
        this.pointAnime = '';

    }
    init(){

        this.$container = document.getElementById("p-top-feature");
        this.$currentPage = document.getElementById("p-top-feature__slide__pager__number").querySelectorAll(".current")[0];
        this.$slideWrap = document.getElementById("p-top-feature__slide__list");
        this.$slideContent = document.getElementById("p-top-feature__slide__list").children;
        this.$slideIconBtn = document.querySelectorAll(".p-top-feature__figure-icon");
        this.$slideIllust = document.getElementById("p-top-feature__illust").querySelectorAll("li");

        this.mot("set");

        document.getElementById("p-top-feature__slide__pager-prev").addEventListener("click",()=>{
            this.update("prev","");
        });

        document.getElementById("p-top-feature__slide__pager-next").addEventListener("click",()=>{
            this.update("next","");
        });

        for(let i in this.$slideIconBtn){
            if(this.$slideIconBtn[i].nodeType!==1) break;
            this.$slideIconBtn[i].addEventListener("click",(e)=>{

                let _select = e.target.getAttribute("data-target");

                if(_select == this.status.current) return;

                this.status.prevCurrent = this.status.current;
                this.status.current = Number(_select);

                this.update(this.status.prevCurrent<this.status.current?"next":"prev","ctrl");
            });
        }

        this.pointPicon(this.$slideIllust[this.status.current-1].querySelectorAll('.point .icon .bg'));

    }
    update(dir,type){


        //直リンクは更新しない
        if(type!=="ctrl"){
            this.status.prevCurrent = this.status.current;
            if(dir == "next"){
                this.status.current = this.status.current<this.conf.max ? this.status.current+1:1;
            }else{
                this.status.current = this.status.current>1 ? this.status.current-1:this.conf.max;
            }
        }


        //currentのアイコンとページャーの表記切り替え
        this.$slideIconBtn[this.status.prevCurrent-1].classList.remove("is-current");
        this.$slideIconBtn[this.status.current-1].classList.add("is-current");

        TweenMax.to(this.$currentPage,0.4,{
            opacity : 0,
            scale : 0.4,
            onComplete:()=>{
                this.$currentPage.textContent = "0" + this.status.current;
                TweenMax.to(this.$currentPage,0.6,{
                    opacity : 1,
                    scale : 1,
                });
            }
        });


        //テキストボックス切り替え
        this.mot("out");
    }
    mot(type){
        if(type=="show"){
            this.$slideContent[this.status.current-1].classList.add("is-current");
            this.resize();
            TweenMax.to([this.$slideContent[this.status.current-1],this.$slideIllust[this.status.current-1]],0.6,{
                opacity : 1,
                scale : 1,
                onComplete:()=>{
                    this.pointPicon(this.$slideIllust[this.status.current-1].querySelectorAll('.point .icon .bg'));
                }
            });

        }else if(type=="out"){
            TweenMax.to([this.$slideContent[this.status.prevCurrent-1],this.$slideIllust[this.status.prevCurrent-1]],0.6,{
                opacity : 0,
                scale : 0.8,
                onComplete:()=>{
                    this.$slideContent[this.status.prevCurrent-1].classList.remove("is-current");
                    this.pointtl = '';
                    this.pointAnime.kill();
                    this.mot("show");
                }
            });
        }else{
            TweenMax.set([this.$slideContent,this.$slideIllust],{
                opacity : 0,
                scale : 0.8,
            });
            TweenMax.set([this.$slideContent[this.status.current-1],this.$slideIllust[this.status.current-1]],{
                opacity : 1,
                scale : 1,
            });
        }
    }
    pointPicon($target){
        if(!$target) return;
        TweenMax.staggerTo($target,0, {
            opacity: 1,
        },0)
        this.pointtl = new TimelineMax({repeat:-1,repeatDelay:0.9});
        this.pointAnime = this.pointtl.staggerTo($target,.9, {
            opacity: 0,
            scale: 1.2,
        },0).staggerTo($target,0, {
            scale: 0.6,
        },0);
    }
    resize(){

        let _h = document.querySelector("#p-top-feature__slide__list .is-current").clientHeight;
        TweenMax.to(this.$slideWrap,0.3,{
            css:{
                'height':_h+'px'
            }
        });

    }
}
